
/**
 * Module dependencies.
 */

import { isPlainObject, isString, mapValues } from 'lodash';

/**
 * Escape string values.
 */

function escapeStringValues(value: any): any {
  if (isString(value)) {
    return escape(value);
  }

  if (isPlainObject(value)) {
    return mapValues(value, escapeStringValues);
  }

  return value;
}

/**
 * Unescape string values.
 */

function unescapeStringValues(value: any): any {
  if (isString(value)) {
    return unescape(value);
  }

  if (isPlainObject(value)) {
    return mapValues(value, unescapeStringValues);
  }

  return value;
}

/**
 * Export `stringifyObject`.
 */

export function stringifyObject(data: any): string {
  return escape(JSON.stringify(mapValues(data, escapeStringValues)));
}

/**
 * Export `parseObject`.
 */

export function parseObject(data: any): any {
  return mapValues(JSON.parse(unescape(data)), unescapeStringValues);
}
